import React, { PureComponent, createContext } from 'react';
import PropTypes from 'prop-types';

import PageViewTracker from 'apps/analytics/services/PageViewTracker';
import { trackRequestParameters } from 'apps/analytics/utils/requestParameters';
import { hasLocationChanged } from 'apps/analytics/utils/analyticLocationComparator';
import config from 'config';
import { getUserJustLoggedIn } from 'apps/dynamicYield/utils';

const { Provider, Consumer } = createContext();

export default class PageView extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object.isRequired,
    stateSupplier: PropTypes.func,
  };

  componentDidMount() {
    this.pageViewTracker.startTrackingNewPageView();
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (hasLocationChanged(prevProps.location, this.props.location)) {
      this.pageViewTracker.shutdownPageViewTracking();
      return { hasLocationChanged: true };
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot && snapshot.hasLocationChanged) {
      this.pageViewTracker.startTrackingNewPageView();
    }
  }

  componentWillUnmount() {
    this.pageViewTracker.shutdownPageViewTracking();
  }

  get trackerContext() {
    const {
      setPageType,
      addPageComponent,
      addPageStatistic,
      addRequestParameter,
      addPageViewGTMData,
    } = this.pageViewTracker;
    return {
      pageView: {
        setPageType,
        addPageComponent,
        addPageStatistic,
        addRequestParameter,
        addPageViewGTMData,
        isJustLoggedIn: getUserJustLoggedIn(),
      },
    };
  }

  pageViewTracker = new PageViewTracker(this.props.stateSupplier);

  render() {
    const { location } = this.props;

    return (
      <Provider value={this.trackerContext}>
        {trackRequestParameters(location)}
        {this.props.children}
      </Provider>
    );
  }
}

export { Consumer as PageViewConsumer };

export const propTypesOfPageViewContext = {
  pageView: PropTypes.shape({
    addPageComponent: PropTypes.func.isRequired,
    addPageStatistic: PropTypes.func.isRequired,
    addRequestParameter: PropTypes.func.isRequired,
    setPageType: PropTypes.func.isRequired,
  }).isRequired,
};

export const checkPageView = (pageView) => {
  if (!config.isServer && !pageView) {
    console.error('pageView not available in context, have you used <PageView> in component tree?'); // eslint-disable-line no-console
  }
};

// for unit test only
export { Provider as PageViewProvider };
